export default __webpack_public_path__ + "static/media/transaction.88a7aed9.svg";